import { render, staticRenderFns } from "./trafficTicketModal.vue?vue&type=template&id=399fe7ab&scoped=true"
import script from "./trafficTicketModal.vue?vue&type=script&lang=js"
export * from "./trafficTicketModal.vue?vue&type=script&lang=js"
import style0 from "./trafficTicketModal.vue?vue&type=style&index=0&id=399fe7ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399fe7ab",
  null
  
)

export default component.exports